import DebtorDialog from "./DebtorDialog";

export default DebtorDialog;
